import { Heading } from "@radix-ui/themes";
import { FONT_SIZE } from "lib/enums/radix-layout";
import { ITextProps } from "lib/interfaces/layout";

const CommonTitle = (props: ITextProps) => (
  <Heading
    className={props.className}
    style={props.style}
    weight={props.weight}
    color={props.color ?? "indigo"}
    size={props.size ?? FONT_SIZE.title}
    align={props.align ? "center" : undefined}
    onClick={props.onClick}
  >
    {props.children}
  </Heading>
);

export default CommonTitle;
